import urls from "../../api/urls.json";
import { authorizedHttpGet } from "../../api/httpCalls";
import { useState, useRef, useEffect } from "react";
import Loader from "../Loader";
import { FlexWrapper } from '../../styles/WrapperStyles'
import styled, { css } from 'styled-components';
import place_holder from '../../assests/placeholder_image.png'
import PageModal from "../modals/PageModal";
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import '../styles/Moderated.css'
import { getSafeMediaUrl } from "../../utils";


const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderWrapper = styled(FlexWrapper)`
    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

function Moderated() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [moderatedImages, setModeratedImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const totalPages = useRef(1);
    const [displayPageModal, setDisplayPageModal] = useState(false);

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
        setPage(1);
    };

    const fetchModeratedImages = async () => {
        setLoading(true);
        let response = await authorizedHttpGet(urls.GET_MODERATED, { "page": page });
        if (response.status) {
            totalPages.current = response.data.total_pages;
            setModeratedImages(response.data.moderation_list);
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchModeratedImages();
    }, [page, appName]);

    const goToPage = (pageNumber) => {
        if (pageNumber <= totalPages.current && pageNumber >= 1) {
            setPage(pageNumber);
        }
        setDisplayPageModal(false);
    }

    const closeModal = () => {
        setDisplayPageModal(false);
    }



    return (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Moderated'} />
            <div className="marginLeft200">
                {loading && <Loader />}
                {displayPageModal && <PageModal goToPage={goToPage} page={page} closeModal={closeModal} />}
                <FlexWrapper className="marginTop25">
                    <HeaderWrapper className="cursorPointer" onClick={() => setDisplayPageModal(true)}>
                        <HeaderSelected>{page}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalPages.current}</HeaderSelected>
                    </HeaderWrapper>
                </FlexWrapper>
                <div className="containerDivModerated">
                    {
                        moderatedImages.map((image) => (
                            <div className="imageDivModerated">
                                <img className="borderRadius10" src={getSafeMediaUrl(image.content, place_holder)} width={200} height={200} onError={(e) => e.target.src = place_holder} /><br />
                                <span>{image.first_name}</span><br />
                                <span>{image.ref}</span><br />
                                <span>{image.labels}</span><br />
                                <span>Confidence: {image.confidence}</span>
                            </div>
                        ))
                    }
                </div>

            </div>
        </div>
    );
};

export default Moderated;
